import React from "react";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import Faq from "../components/home/Faq";
import Navbar2 from "../components/Navbar2";

function FaqPage() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Navbar2 />
      <HeroPages name={"FAQ"} />
      <Faq />
      <Footer />
    </>
  );
}

export default FaqPage;
